import {
  IconBasketFilled,
  IconSettingsFilled,
  IconUserCircle,
} from "@tabler/icons-react";
import { ItemType } from "antd/es/menu/hooks/useItems";
import { Link } from "react-router-dom";
import CheckIcon from "./../../library/icons/CheckIcon";
import LockIcon from "library/icons/LockIcon";
import {
  BirthDayIcon,
  EventIcon,
  ExchangeIcon,
  MagazineIcon,
  MemberIcon,
  NicheIcon,
  PromotionIcon,
  RightIcon,
  ShipingIcon,
  SupportIcon,
} from "library/icons/reward";

const styleIcon = {
  width: 14,
  height: 14,
};
const CustomerConstants = {
  PROFILE_MENU: [
    {
      label: <Link to="myprofile">My Profile</Link>,
      key: "myprofile",
      icon: <IconSettingsFilled style={{ ...styleIcon }} />,
      children: [
        {
          label: <Link to="myprofile/view"> View Profile</Link>,
          icon: <IconUserCircle style={{ ...styleIcon }} />,
        },
        // {
        //   label: <Link to="myprofile/update"> Update Profile</Link>,
        //   icon: <ProfileOutlined />,
        // },
      ],
    },
    {
      label: <Link to="myorder">My Order</Link>,
      key: "myorder",
      icon: <IconBasketFilled style={{ ...styleIcon }}></IconBasketFilled>,
    },
    // {
    //   label: <Link to="comment">Comment</Link>,
    //   key: "comment",
    //   icon: <IconBasketFilled style={{ ...styleIcon }}></IconBasketFilled>,
    // },
    {
      label: <Link to="/coupon">Coupon</Link>,
      key: "test",
      icon: <IconBasketFilled style={{ ...styleIcon }}></IconBasketFilled>,
    },
  ] as ItemType[],
  LINK_ROUTER: {
    CUSTOMER: {
      INDEX: "/me",
      MY_PROFILE: "/myprofile",
      RESET_PASSWORD: "/myprofile/resetpassword",
      MY_COUPON: "/mycoupon",
      MY_ADDRESS: "/myaddress",
      MY_REWARD: "/myreward",
    },
    LOGIN: {
      INDEX: "/",
      REGISTER: "/register",
      VERIFY_OTP: "/verifyotp",
      FORGOT_PASSWORD: "/forgotpassword",
      RESET_PASSWORD: "/resetpassword",
    },
    NEW_LETTER: {
      INDEX: "",
    },
  },
  NTACCOUNTID: {
    TYPE_CHANGE_EMAIL: 4, //dùng cho giao diện thay đổi email
    TYPE_CHANGE_PHONE: 5, //dùng cho giao diện thay đổi phone
  },
  SENDER_TYPE: {
    CHANGE_CONTACT: 10, //thay đổi email và phone
    CHANGE_USERNAME: 11, //update username
    VERIFY: 12, //verify
    PROFILE: 13,
    NEWSLETTER: 6, //đăng ký nhận tin
  },
  ERRORS: {
    ERROR_OTP_ALREADY: "error_otp_already",
    ERROR_OVER_LIMIT: "error_over_limit",
    ERROR_TIMECHANGE_USERNAME: "error_time_change_user_name",
    // ERROR_TIMECHANGE_CONTACT: "error_time_change_contact",
    ERROR_TIMECHANGE_EMAIL: "error_time_change_email",
    ERROR_TIMECHANGE_PHONE: "error_time_change_phone",
    // ERROR_TIMECHANGE_CONTACT_EMAIL: "error_time_change_contact_email",
    // ERROR_TIMECHANGE_CONTACT_PHONE: "error_time_change_contact_phone",
    ERROR_TIMECHANGE: "error_time_change",
    ERROR_CONTACTID_EXIST: "error_contactid_exist",
  },
  STATUS: {
    CHANGE_USERNAME_SUCCESS: "CHANGE_USERNAME_SUCCESS",
    CHANGE_EMAIL_SUCCESS: "CHANGE_EMAIL_SUCESS",
    CHANGE_PHONE_SUCCESS: "CHANGE_PHONE_SUCCESS",
    CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
    VERIFY_EMAIL_SUCCESS: "VERIFY_EMAIL_SUCCESS",
    VERIFY_PHONE_SUCCESS: "VERIFY_PHONE_SUCCESS",
  },
  MEMBER_BENEFITS: [
    {
      title: "quyền lợi",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          case 1:
            return {
              des: [
                "Giảm 10% cho đơn hàng đầu tiên khi được ghi nhận thành viên",
              ],
            };
          case 2:
            return {
              des: ["Giảm 10% cho cho mọi hóa đơn"],
            };

          default:
            return {
              des: ["Giảm 12% cho mọi hóa đơn"],
            };
        }
      },

      icon: <RightIcon></RightIcon>,
      rank: [1, 2, 3, 4],
    },
    {
      title: "Khuyến mãi",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          default:
            return {
              des: ["Ưu tiên nhận thông tin chương trình khuyến mãi"],
            };
        }
      },
      icon: <PromotionIcon></PromotionIcon>,
      rank: [1, 2, 3, 4],
    },
    {
      title: "thành viên",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          default:
            return {
              des: ["Giảm giá độc quyền khách hàng"],
            };
        }
      },
      icon: <MemberIcon></MemberIcon>,
      rank: [1, 2, 3, 4],
    },
    {
      title: "sinh nhật",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          case 1:
            return {
              des: ["Giảm 10% / hóa đơn tối đa 15 triệu"],
            };

          case 4:
            return {
              des: ["Giảm 15% / hóa đơn tối đa 15 triệu, Quà tặng bất ngờ"],
            };
          default:
            return {
              des: ["Giảm 15% / hóa đơn tối đa 15 triệu"],
            };
        }
      },
      icon: <BirthDayIcon></BirthDayIcon>,
      rank: [1, 2, 3, 4],
    },

    {
      title: "giao hàng",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          default:
            return {
              des: ["Miễn phí giao hàng "],
            };
        }
      },
      icon: <ShipingIcon></ShipingIcon>,
      rank: [1, 2, 3, 4],
    },

    {
      title: "magazine",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          default:
            return {
              des: [<>Nhận ấn phẩm độc quyền từ namperfume</>],
            };
        }
      },
      icon: <MagazineIcon></MagazineIcon>,
      rank: [3, 4],
    },
    {
      title: "new design",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          default:
            return {
              des: ["Ưu tiên trải nghiệm sản phẩm Design mới"],
            };
        }
      },

      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={25}
          height={24}
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M6.5 21L6.31092 17.9747C5.87149 10.9438 11.4554 5 18.5 5V5L17.2827 5.97387C14.8918 7.88656 13.5 10.7824 13.5 13.8442V13.8442C13.5 15.9831 11.5278 17.5774 9.43642 17.1292L6.5 16.5"
            stroke="#3A393A"
            strokeWidth="1.5"
          />
        </svg>
      ),
      rank: [3, 4],
    },
    {
      title: "new niche",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          default:
            return {
              des: ["Ưu tiên trải nghiệm sản phẩm Niche mới"],
            };
        }
      },
      icon: <NicheIcon></NicheIcon>,
      rank: [4],
    },
    {
      title: "đổi trả",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          case 3:
            return {
              des: ["Gia hạn thời gian đổi trả lên đến 7 ngày"],
            };
          default:
            return {
              des: ["Gia hạn thời gian đổi trả lên đến 14 ngày"],
            };
        }
      },

      icon: <ExchangeIcon></ExchangeIcon>,
      rank: [3, 4],
    },
    {
      title: "sự kiện",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          default:
            return {
              des: [<>Nhận vé mời sự kiện VIP của namperfume</>],
            };
        }
      },

      icon: <EventIcon />,
      rank: [4],
    },
    {
      title: "hỗ trợ",
      descriptions: (rank_id: number) => {
        switch (rank_id) {
          default:
            return {
              des: ["Được chuyên viên chăm sóc và hỗ trợ"],
            };
        }
      },
      icon: <SupportIcon></SupportIcon>,
      rank: [4],
    },
  ],
  MEMBER_BENEFITS_COMING: {
    MEMBER: [
      {
        title: "Giảm giá độc quyền tại namperfume",
        des: "Hãy tận hưởng các ưu đãi của thẻ Gold. Chúng tôi sẽ cho bạn biết khi phần thưởng này sẵn sàng",
        icon: <CheckIcon></CheckIcon>,
      },
      {
        title: "Free Shipping",
        des: "Freeship cho mọi đơn hàng",
        icon: <CheckIcon></CheckIcon>,
      },
    ],
    GOLD: [
      {
        title: "Magazine",
        des: "Nhận ấn phẩm độc quyền của namperfume",
        icon: <LockIcon></LockIcon>,
      },
      {
        title: "Đổi trả",
        des: "Gia hạn thời gian đổi trả lên đến 7 ngày",
        icon: <LockIcon></LockIcon>,
      },
      {
        title: "New Design",
        des: "Ưu tiên trải nghiệm sản phẩm Design mới",
        icon: <LockIcon></LockIcon>,
      },
    ],
    PLATINUM: [
      {
        title: "New Niche",
        des: "Ưu tiên trải nghiệm sản phẩm Niche mới",
        icon: <LockIcon></LockIcon>,
      },
      {
        title: "Hỗ trợ",
        des: "Được chuyên viên chăm sóc và hỗ trợ",
        icon: <LockIcon></LockIcon>,
      },
      {
        title: "Sự kiện",
        des: "Nhận vé mời sự kiện VIP của namperfume",
        icon: <LockIcon></LockIcon>,
      },
    ],
  },

  RANK_TYPE: {
    MEMBER: {
      ID: 1,
      DES: "Thành viên",
      LABEL: "Member",
    },
    GOLD: {
      ID: 2,
      DES: "Thành viên hạng Vàng",
      LABEL: "Gold",
    },
    PLATINUM: {
      ID: 3,
      DES: "Thành viên hạng Bạch Kim",
      LABEL: "Platinum",
    },
    NICHE: {
      ID: 4,
      DES: "Thành viên hạng Niche",
      LABEL: "Niche",
    },
  },

  RANK_EVENT: {
    ITEM_TYPE_UP_RANK: 1,
    ITEM_TYPE_DOWN_RANK: 2,
    ITEM_TYPE_KEEP_RANK: 3,
    ITEM_TYPE_JOIN_REWARD: 4,
  },
};

export default CustomerConstants;
